import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Toolbar, Typography } from "@mui/material";
import * as React from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import ReusableCard from "../../components/card/ReusableCard";
import "./PhotoUpload.scss";
import UploadFile from "../../components/photo-upload/UploadFile";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ADL_Sidebar_Logo from "../../assets/images/ADL_Logo_White.webp"
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/root/config.store";
import SnackbarNotifier from "../../components/snackbar/Snackbar";
import { clearAllFiles } from "../../store/photoUploadUploadFile/slice";
import { showSnackbar } from "../../store/snackbar/slice";
import OrderInformation from "../../components/photo-upload/OrderInformation";
import { PhotoUploadFormData, PhotoUploadPayload, ValidateTokenPayload } from "../../types/photoUpload";
import {useValidateTokenService, usePhotoUploadService} from "../../services/photoUpload/service";
import { photoUploadActions } from "../../store/photoUpload/slice";

export default function PhotoUpload(props: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [uploadKey, setUploadKey] = useState(0);
  const [searchParams] = useSearchParams();
  const validateTokenResponse = useSelector(
          (state: RootState) => state.photoUpload
        );
  const { validateToken, submitValidateToken } = useValidateTokenService();
  const token = searchParams.get("token");
  useEffect(() => {
    const tokenValidate: ValidateTokenPayload = {
      token: token || "",
    }
    submitValidateToken(tokenValidate);
  }, [token]);

  useEffect(() => {
    if(validateTokenResponse !== null && validateTokenResponse?.validateTokenData?.statuscode !== 400){
      methods.setValue("OrderNo", validateTokenResponse?.validateTokenData?.data?.orderNo);
      methods.setValue("ShopName", validateTokenResponse?.validateTokenData?.data?.shopName);
      methods.setValue("AccountName", validateTokenResponse?.validateTokenData?.data?.account);
      methods.setValue("PONumber", validateTokenResponse?.validateTokenData?.data?.poNumber);
    }
  }, [validateTokenResponse]);

  const handleAddMore = () => {
    navigate("/label-catalog", {
      state: { returnToQuickOrder: true },
    });
  };

  const { photoUpload, submitPhotoUpload} =
    usePhotoUploadService();
  const storedDataInfo = localStorage.getItem("customerInfo");
  const customerInfoValues = storedDataInfo ? JSON.parse(storedDataInfo) : {};

  const methods = useForm<PhotoUploadFormData>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      OrderAttachments: [],
      OrderNo: "",
      AccountName: "",
      ShopName: "",
      PONumber: ""
    },
  });

  const onReset = () => {
    dispatch(photoUploadActions.resetPhotoUploadState());
    dispatch(clearAllFiles());
    methods.reset({
      OrderAttachments: [],
      OrderNo: "",
      ShopName: "",
      AccountName: "",
      PONumber: ""
    });
  }

  const onSubmit = (data: PhotoUploadFormData) => {
    if ((!data.OrderAttachments || data.OrderAttachments?.filter((file) => file?.isActive)?.length === 0)
    ) {
      dispatch(showSnackbar({
        message: "At least one attachment is required.",
        severity: "error",
      }))
      return false;
    }

    const updatedData: PhotoUploadPayload = {
      OrderAttachments: data.OrderAttachments,
      UserName: "",
      UserID: 0,
      EmailReceivedDateTime: new Date(),
      TokenId: validateTokenResponse?.validateTokenData?.data?.tokenId,
      OrderId: validateTokenResponse?.validateTokenData?.data?.orderId
    };

    submitPhotoUpload({ ...updatedData });
  };
 
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <SnackbarNotifier />
        <Box
          className="drawer-logo" width={"100%"}
          sx={{
            display: "flex",
            alignItems: "left",
            justifyContent: "normal",
            backgroundColor: " #014C8A",
            padding: "35px 20px",
            marginBottom: "15px",
            color: "white"
          }}
        >
          <Typography style={{ width: "40%" }}>
            <img
              className={"sidebar-logo"}
              src={ADL_Sidebar_Logo}
              style={{
                transition: "width 0.15s",
                height: 55,
                width: "auto",
                objectFit: "contain",
                display: "block"
              }}
              alt="ADL Logo"
            />
          </Typography>
          <Typography variant="h4" style={{ fontWeight: "500", width: "60%" }}>Upload Label Images</Typography>

        </Box>
        { validateTokenResponse?.validateTokenData?.statuscode === 200  && validateTokenResponse?.photoUploadData?.success !== true &&
          <Box className="guest-order-wrapper">
            <Box className="info">
              <ReusableCard title="Order Information">
                <OrderInformation />
              </ReusableCard>
            </Box >
            <Box className="info">
              <UploadFile key={uploadKey} onAddMore={handleAddMore} />
            </Box>
            <ReusableCard
              contentSx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="contained"
                className="search-button" style={{ marginRight: "10px" }}
                onClick={onReset}
              >
                Reset
              </Button>

              <Button
                type="submit"
                variant="contained"
                className="search-button"
              >
                Submit
              </Button>

            </ReusableCard>
          </Box>
        }

        {validateTokenResponse?.validateTokenData?.statuscode === 400 &&
           <Box>
              <Typography style={{height: "70vh", display: "flex", justifyContent: "center", textAlign: "center", alignItems:"center", fontWeight:"bold", fontSize:"1.5rem", color:"red"}}>{validateTokenResponse?.validateTokenData?.message}</Typography>
           </Box>
        }

         {validateTokenResponse?.photoUploadData?.success === true &&
           <Box>
            <Typography style={{height: "70vh", display: "flex", justifyContent: "center", textAlign: "center", alignItems:"center", fontWeight:"bold", fontSize:"1.5rem", color:"green"}}>Images uploaded successfully against Order #{validateTokenResponse?.validateTokenData?.data?.orderNo}</Typography>
          </Box>
        }

      </form>

    </FormProvider>
  );
}
